<div class="row">
  <div class="col-xl-8">
    <div *ngIf="(ctc ?? 0) > 0 && payout !== null">
      <div class="d-flex justify-content-between">
        <p>Effective From</p>
        <p>
          {{ payout.effectiveFrom | date: 'MMM dd, yyyy' }}
        </p>
      </div>
      <div class="d-flex justify-content-between">
        <p>Compliances</p>
        <div>
          <ng-container *ngIf="hasValidCompliances(); else noCompliance">
            <ng-container *ngFor="let compliance of salaryCompliancesList | keyvalue">
              <span
                class="badge bg-soft-info me-1"
                *ngIf="compliance.key !== 'employerCapping' && compliance.value === true"
              >
                {{ compliance.key + '' | uppercase }}
              </span>
            </ng-container>
          </ng-container>

          <ng-template #noCompliance>
            <span>None</span>
          </ng-template>
        </div>
      </div>
      <div class="d-flex justify-content-between">
        <p>Total CTC</p>
        <p>
          {{
            payout !== undefined && payout !== null
              ? (ctc | currency: currency ?? 'INR' : 'symbol' : '1.0-0' : 'en-IN')
              : ''
          }}
        </p>
      </div>
      <div class="d-flex justify-content-between">
        <p>Basis</p>
        <p>
          {{ payout !== undefined && payout !== null ? formatEnumValues(basis ?? '') : '' }}
        </p>
      </div>
      <div class="d-flex justify-content-between">
        <p>Payout Frequency</p>
        <p>
          {{
            payout !== undefined && payout !== null ? formatEnumValues(payoutFrequency ?? '') : ''
          }}
        </p>
      </div>
      <div class="d-flex justify-content-between">
        <p>Currency</p>
        <p>{{ currency ?? 'INR' }}</p>
      </div>
      <!--Salary Summary-->
      <table class="table datatable">
        <thead class="thead-light">
          <tr>
            <th>Payout Component</th>
            <th>Type</th>
            <th>Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of payoutDataArr">
            <ng-container
              *ngIf="item[0] !== 'otherComponents' && typeof item[1] === 'number' && item[1] > 0"
            >
              <td style="word-wrap: break-word; white-space: normal">
                {{ item[0] }}
              </td>
              <td>
                <span class="badge bg-soft-info">Earning</span>
              </td>
              <td>
                {{ item[1] | currency: currency ?? 'INR' : 'symbol' : '1.0-0' : 'en-IN' }}
              </td>
            </ng-container>
          </tr>
          <ng-container *ngFor="let item of payout?.payoutData?.otherComponents">
            <tr *ngIf="item.componentType !== 'customDeductions'; else elseBlock">
              <td style="word-wrap: break-word; white-space: normal">
                {{ item.name }}
              </td>
              <td>
                <span class="badge bg-soft-info">{{
                  item.componentType === 'customDeductions' ? 'Deduction' : 'Earning'
                }}</span>
              </td>
              <td>
                {{
                  item.employerContribution
                    | currency: currency ?? 'INR' : 'symbol' : '1.0-0' : 'en-IN'
                }}
              </td>
            </tr>
            <ng-template #elseBlock>
              <tr>
                <td style="word-wrap: break-word; white-space: normal">
                  {{ item.name }} - Employer Contribution
                </td>
                <td>
                  <span class="badge bg-soft-info">{{
                    item.componentType === 'customDeductions' ? 'Deduction' : 'Earning'
                  }}</span>
                </td>
                <td>
                  {{
                    item.employerContribution
                      | currency: currency ?? 'INR' : 'symbol' : '1.0-0' : 'en-IN'
                  }}
                </td>
              </tr>
              <tr>
                <td style="word-wrap: break-word; white-space: normal">
                  {{ item.name }} - Employee Contribution
                </td>
                <td>
                  <span class="badge bg-soft-info">{{
                    item.componentType === 'customDeductions' ? 'Deduction' : 'Earning'
                  }}</span>
                </td>
                <td>
                  {{
                    item.employeeContribution
                      | currency: currency ?? 'INR' : 'symbol' : '1.0-0' : 'en-IN'
                  }}
                </td>
              </tr>
            </ng-template>
          </ng-container>
          <!--<tr>
                              <td>CTC</td>
                              <td>
                                <span class="badge bg-soft-info">Earning</span>
                              </td>
                              <td>{{ employeeSalaryDetails.ctc.ctc }}</td>
                            </tr>-->
        </tbody>
      </table>
    </div>
  </div>
  <div class="col-xl-4">
    <div class="card" *ngIf="(ctc ?? 0) > 0 && payout !== null">
      <div class="card-body">
        <div class="d-flex flex-column gap-3">
          <!--<button
                                      (click)="openBusinessModal(previewMonthlySalary)"
                                      class="btn btn-primary"
                                      type="button"
                                      *appHasPermission="[{ employeeSalary: ['view'] }]"
                                    >
                                      Preview Monthly Salary
                                    </button>-->
          <button
            [routerLink]="[eps.hrm.revisePayoutPath, employeeId]"
            class="btn btn-primary"
            type="button"
            *appHasPermission="[{ employeeSalary: ['edit'] }]"
          >
            Revise Payout
          </button>
          <button
            [routerLink]="[eps.hrm.updatePayoutPath, employeeId]"
            class="btn btn-primary"
            type="button"
            *appHasPermission="[{ employeeSalary: ['edit'] }]"
          >
            Update Payout
          </button>
          <button
            (click)="openBusinessModal(viewAllPayouts)"
            class="btn btn-primary"
            type="button"
            *appHasPermission="[{ employeeSalary: ['view'] }]"
          >
            View All Payouts
          </button>
          <button
            [routerLink]="[eps.hrm.contractorPayrollSummaryPath, employeeId]"
            class="btn btn-primary"
            type="button"
            *appHasPermission="[{ payroll: ['view'] }]"
          >
            Payroll Summary
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- View All Salaries -->
<ng-template #viewAllPayouts let-modal>
  <div class="modal-header">
    <h4 class="modal-title">
      Payouts of {{ (employee$ | async)?.firstName }}
      <small class="text-muted">{{ (employee$ | async)?.empId }}</small>
    </h4>
    <button
      type="button"
      class="btn-close custom-btn-close"
      data-bs-dismiss="modal"
      aria-label="Close"
      (click)="onClose()"
    >
      <i class="ti ti-x"></i>
    </button>
  </div>
  <div class="modal-body pb-0">
    <div *ngIf="employee$ | async as employee" class="container mt-4">
      <div class="row">
        <div class="col-md-12">
          <table class="table">
            <thead class="thead-light">
              <tr>
                <th>CTC</th>
                <th>Basis</th>
                <th>Payout Frequency</th>
                <th>Effective From</th>
                <th>Payout From</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let payout of allPayoutAgreements$ | async">
                <td>
                  {{ payout.ctc | currency: currency ?? 'INR' : 'symbol' : '1.0-0' : 'en-IN' }}
                </td>
                <td>{{ payout?.basis ?? '' | capitalize }}</td>
                <td>{{ formatEnumValues(payout?.payoutFrequency ?? '') }}</td>
                <td>{{ payout?.effectiveFrom | date: 'MMM dd, yyyy' }}</td>
                <td>{{ payout?.payoutFrom | date: 'MMM yyyy' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer"></div>
</ng-template>
<!-- /View All Salaries -->
